<template>
  <div class="container">
    <h1 class="text-center">Posts</h1>
    <hr />
    <div v-if="getPosts().length">
      <br />
      <div class="posts-grid">
        <div
          :key="index"
          v-for="(post, index) in getPosts()"
          class="posts-grid-col"
        >
          <PostCard :post="post" />
        </div>
      </div>
      <div class="center con-pagination">
        <Paginator
          :first="first"
          :rows="6"
          :totalRecords="totalPosts"
          @update:first="onPageChange"
        />
      </div>
    </div>
    <Nothing v-else />
  </div>
</template>

<script>
import PostCard from '@/components/PostCard.vue'
import Nothing from '@/components/Nothing.vue'
import Paginator from 'primevue/paginator'

export default {
  name: 'ViewPosts',
  components: {
    PostCard,
    Nothing,
    Paginator
  },
  data: function () {
    return {
      // 扁平文章数组(mounted 前的原始输入)
      allPosts: this.getConfig('posts.json').posts,
      // mounted 后会变成"页数组"(每页 6 篇)。totalPosts 保存扁平总数给 Paginator
      totalPosts: 0,
      // PrimeVue Paginator 用 0-based first 索引;原项目 curPage 是 1-based
      curPage: 1,
      first: 0,
      config: this.getConfig().config
    }
  },
  mounted: function () {
    this.changeTitle('Posts')
    const posts = this.allPosts
    this.totalPosts = posts.length
    this.allPosts = []
    for (let i = 0; i < posts.length; i += 6) this.allPosts.push(posts.slice(i, i + 6)) // pagination, 6 posts per page
  },
  methods: {
    onPageChange: function (newFirst) {
      // PrimeVue 传 0-based 起始索引,转回 1-based 页码
      this.first = newFirst
      this.curPage = newFirst / 6 + 1
    },
    getPosts: function () {
      try {
        return this.allPosts[this.curPage - 1].slice().reverse()
      } catch (e) {
        return []
      }
    }
  }
}
</script>

<style scoped>
/* 原生 CSS Grid 替代 Gridlex 的 .grid-3_xs-1_sm-2_md-2
   (Gridlex 与 PostCard 内部 flex 布局冲突导致 card 重叠/拉伸) */
.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.posts-grid-col {
  display: flex;
  align-items: stretch;
}
</style>
